// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartOverlayStorageRenderer } from '@front/chart/Renderers/TerceraChartOverlayStorageRenderer';
import { OverlaysManagerItem } from '../../cache/ObjectManager/OverlaysManagerItem';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { ObjectManagerPanelBase } from './ObjectManagerPanelBase';
import { TerceraChartActionEnum } from '@front/chart/TerceraChartAction';
export class OverlaysManagerPanel extends ObjectManagerPanelBase {
    constructor() {
        super();
        this.ChartActionVisibility = TerceraChartActionEnum.PlateOverlayVisible;
        this.ChartActionSettings = TerceraChartActionEnum.PlateOverlaySettings;
        this.ChartActionRemove = TerceraChartActionEnum.PlateOverlayRemove;
        this.ChartActionDeleteAll = TerceraChartActionEnum.Overlay;
        this.Name = 'OverlaysManagerPanel';
        this.headerLocaleKey = 'chart.head.overlays';
    }
    getType() {
        return PanelNames.OverlaysManagerPanel;
    }
    subscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            this.Chart.OnAddOverlay.Subscribe(this.AddItemToTable, this);
            this.Chart.OnRemoveOverlay.Subscribe(this.RemoveItemFromTable, this);
        }
    }
    unsubscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            this.Chart.OnAddOverlay.UnSubscribe(this.AddItemToTable, this);
            this.Chart.OnRemoveOverlay.UnSubscribe(this.RemoveItemFromTable, this);
        }
    }
    AddItemToTable(overlay) {
        const quickTable = super.getQuickTable();
        if (isNullOrUndefined(quickTable)) {
            return;
        }
        quickTable.AddItem(new OverlaysManagerItem(overlay));
    }
    populateItemsDirect() {
        super.populateItemsDirect();
        const renderer = this.Chart.mainWindow.GetRenderer(TerceraChartOverlayStorageRenderer);
        this.populateItems(renderer.OverlaysWindows);
    }
    populateItems(renderers) {
        for (const renderer of renderers) {
            this.AddItemToTable(renderer.Overlay);
        }
    }
}
